var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriwinkle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 73,
    viewBox: "0 0 86 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.483749,
    d: "M23.5656 3.53832C23.2685 -13.1042 46.6665 -17.0541 51.8491 -1.23626C54.241 6.06421 61.1137 10.9517 68.7948 10.8145C85.4373 10.5174 89.3872 33.9154 73.5694 39.098C66.2689 41.4899 61.3815 48.3626 61.5186 56.0437C61.8158 72.6862 38.4177 76.6361 33.2352 60.8183C30.8433 53.5178 23.9705 48.6304 16.2894 48.7675C-0.353086 49.0647 -4.30296 25.6666 11.5148 20.4841C18.8153 18.0922 23.7028 11.2194 23.5656 3.53832Z",
    fill: "#27AE60",
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriwinkle4);
export default __webpack_public_path__ + "static/media/Periwinkle4.a0fee4cf33772a176dc778f833f97bdf.svg";
export { ForwardRef as ReactComponent };